import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import('@/pages/Dashboard/index.vue'),
  },
  // {
  //   path: "/",
  //   name: "Contact",
  //   component: () => import('@/pages/Contact/index.vue'),
  // },
  {
    path: "/contact",
    name: "Contact",
    component: () => import('@/pages/Contact/index.vue'),
  },
  {
    path: "/marketing",
    name: "Marketing",
    component: () => import('@/pages/Marketing/index.vue'),
  },
  {
    path: "/report",
    name: "Report",
    component: () => import('@/pages/Report/index.vue'),
  },
  {
    path: "/task",
    name: "Task",
    component: () => import('@/pages/Task/index.vue'),
  },
  {
    path: "/task/automation",
    name: "TaskAutomation",
    component: () => import('@/pages/Task/AutomationPage.vue'),
  },
  {
    // Calendar — single canonical view of appointments + task dueAts.
    // Replaces the in-page tab on /task; reuses AppointmentCalendar so the
    // calendar source stays in one place (also covers the "đồng bộ lịch
    // hẹn với lịch làm việc về 1 nguồn" requirement).
    path: "/calendar",
    name: "Calendar",
    component: () => import('@/pages/Calendar/index.vue'),
  },
  {
    path: "/setting/sale-performance",
    name: "SalePerformance",
    component: () => import('../pages/SettingPerformance'),
  },

  {
    path: "/setting/general",
    name: "SettingGeneral",
    component: () => import('../pages/SettingGeneral'),

  },
  {
    path:"/setting/sync",
    name:"SyncData",
    component: () => import('../pages/SettingSyncData'),
  },
  {
    path:"/setting/messaging",
    name:"SettingMessaging",
    component: () => import('../pages/SettingMessaging'),
  },
  {
    path:"/setting/call-center",
    name:"CallCenter",
    component: () => import('../pages/CallCenter'),
  }
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
